var heading_default = {
  "fontElementMap": "GDQgN",
  "elementSpacing": "pxEvL",
  "headerOne": "KMkyE pxEvL",
  "headerTwo": "WPFEQ pxEvL",
  "headerThree": "_3I1FP pxEvL",
  "headerFour": "_18arS pxEvL",
  "headerFive": "I-VAI pxEvL",
  "headerSix": "wDYpC pxEvL",
  "child": "fYXZj"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
